import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

/**
 * FormulationSection - a single section of the clinical formulation form.
 */
const FormulationSection = ({ title, hint, value, onChange, maxWordGuide = 100, compact = false }) => {
  const wordCount = value ? value.trim().split(/\s+/).filter(Boolean).length : 0;

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant={compact ? 'subtitle2' : 'subtitle1'} fontWeight={600} gutterBottom>
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        {hint}
      </Typography>
      <TextField
        multiline
        fullWidth
        minRows={compact ? 2 : 4}
        maxRows={12}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        size="small"
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
        <Typography
          variant="caption"
          color={wordCount > maxWordGuide ? 'warning.main' : 'text.secondary'}
        >
          {wordCount} / ~{maxWordGuide} words
        </Typography>
      </Box>
    </Paper>
  );
};

export { FormulationSection };
export default FormulationSection;
